/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Setting_OnlineInputs */



/**
* | output |
* | --- |
* | "Online" |
*
* @param {Tournament_Wiz_Setting_OnlineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_setting_online = /** @type {((inputs?: Tournament_Wiz_Setting_OnlineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Setting_OnlineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En ligne")
	if (locale === "es") return /** @type {LocalizedString} */ ("En línea")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Online")
	if (locale === "it") return /** @type {LocalizedString} */ ("Online")
	return /** @type {LocalizedString} */ ("Online")
});